<template>
  <div class="stepper-container">
    <div
      v-for="(stepLabel, index) in stepLabels"
      :key="index"
      class="stepper-with-label"
    >
      <div>
        <div class="step-value-with-line" :class="getStepBoxClass">
          <div
            class="left-line"
            :class="getComputedClass(index, 'LEFT_LINE')"
          ></div>
          <div
            class="step-Elem"
            :class="
              `${getComputedClass(index, 'STEP_ELEMENT')} ${getStepElemClass}`
            "
          >
            {{ getStepElemValue(index) }}
            <BaseIcon
              name="verifiedAccent"
              width="1.5rem"
              height="1.5rem"
              v-if="dispCompletionIcon(index)"
            />
          </div>
          <div
            class="right-line"
            :class="getComputedClass(index, 'RIGHT_LINE')"
          ></div>
        </div>
        <div
          class="stepper-label"
          :class="getLabelClass(index)"
          :style="labelStyle"
        >
          {{ stepLabel }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /**
     *
     * Array containing the stepper labels
     *
     */
    stepLabels: {
      type: Array,
      required: true
    },
    /**
     *
     * Current step value should start from 1.
     *
     */
    currentStage: {
      type: Number,
      default: 1
    },
    /**
     *
     * Stepper type can be Numeric or Completion
     *
     */
    stepperType: {
      type: String,
      default: 'Numeric'
    },
    /**
     *
     * Style object to modify the stepper label style
     *
     */
    labelStyle: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    getStepBoxClass() {
      return this.stepperType === 'Numeric' ? '' : 'step-comp-value-with-line';
    },
    getStepElemClass() {
      return this.stepperType === 'Completion'
        ? 'step-elem-comp-type'
        : 'step-elem-num-type';
    }
  },
  methods: {
    getLabelClass(index) {
      if (this.stepperType === 'Numeric') {
        return index === this.currentStage - 1 && 'highlightText';
      } else {
        return index <= this.currentStage - 1
          ? 'highlightText'
          : 'stepper-label-comp';
      }
    },
    getStepElemValue(index) {
      return this.stepperType === 'Numeric' ? index + 1 : '';
    },
    getSideLineClass(isHighlight) {
      if (this.stepperType === 'Numeric') {
        return isHighlight && 'highlightLine';
      } else {
        return isHighlight ? 'highlightSolidLine' : 'line-disabled-comp';
      }
    },
    getCurrStepClass() {
      return this.stepperType === 'Numeric'
        ? 'currentStep'
        : 'completedCurrStep';
    },
    getFinshedStepClass(isFinished) {
      if (this.stepperType === 'Numeric') {
        return isFinished && 'completedStep';
      } else {
        return !isFinished && 'step-Elem-comp';
      }
    },
    dispCompletionIcon(index) {
      return this.stepperType === 'Completion' && index < this.currentStage - 1;
    },
    getComputedClass(index, eleType) {
      if (eleType === 'LEFT_LINE') {
        return index === 0
          ? 'disableLine'
          : this.getSideLineClass(index <= this.currentStage - 1);
      }

      if (eleType === 'STEP_ELEMENT') {
        return index === this.currentStage - 1
          ? this.getCurrStepClass()
          : this.getFinshedStepClass(index < this.currentStage - 1);
      }

      if (eleType === 'RIGHT_LINE') {
        return index == this.stepLabels.length - 1
          ? 'disableLine'
          : this.getSideLineClass(index < this.currentStage - 1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.stepper-container {
  display: flex;
}
.stepper-with-label {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.step-Elem {
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.step-elem-num-type {
  width: 2rem;
  height: 2rem;
  border: 0.063rem solid $color-white;
}
.step-elem-comp-type {
  margin: 0rem 1rem;
  width: 1.5rem;
  height: 1.5rem;
}
.step-Elem-comp {
  border: 0.063rem solid $stepper-disabled-grey;
}
.stepper-with-line {
  display: flex;
  align-items: center;
}
.step-value-with-line {
  display: flex;
  align-items: center;
  margin: 0rem 0.5px;
}
.step-comp-value-with-line {
  margin: 0;
}
.left-line {
  border-bottom: 0.063rem dashed $color-white;
  flex: 1;
}
.right-line {
  border-bottom: 0.063rem dashed $color-white;
  flex: 1;
}
.line-disabled-comp {
  border-bottom: 0.063rem solid $stepper-disabled-grey;
}
.stepper-label {
  width: 11rem;
  display: flex;
  justify-content: center;
  margin-top: 0.625rem;
}
.stepper-label-comp {
  color: $stepper-disabled-grey;
}
.disableLine {
  border: none;
}
.currentStep {
  border: 0.063rem solid $color-brand-accent;
  background-color: #342c1e;
}
.completedCurrStep {
  border: 0.313rem solid $color-brand-accent;
  border-radius: 50%;
  height: 1.5rem;
  width: 1.5rem;
}
.completedStep {
  border: 0.063rem solid $color-brand-accent;
  background-color: $color-brand-accent;
  color: $color-black;
}
.highlightLine {
  border-color: $color-brand-accent;
}
.highlightText {
  color: $color-brand-accent;
}
.highlightSolidLine {
  border-bottom: 0.063rem solid $color-brand-accent;
}
</style>
